import { OFF_WHITE } from "./index.style.ts";

export const listOfMonths = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const listOfBudgets = ["expense", "income"];

export const budgetSortOptions = [
  {
    id: 0,
    label: "A - Z",
  },
  {
    id: 1,
    label: "Z - A",
  },
  {
    id: 2,
    label: "High - Low",
  },
  {
    id: 3,
    label: "Low - High",
  },
  {
    id: 4,
    label: "Paid",
  },
  {
    id: 5,
    label: "Unpaid",
  },
];

export const budgetQuotes = [
  '"Revenue is vanity, profit is sanity, but cash is king." by Anonymous',
  '"Never take your eyes off the cash flow because it\'s the lifeblood of business." by Richard Branson',
  '"The first step in exceeding your customer\'s expectations is to know those expectations." by Roy H. Williams',
  '"Pay yourself first — your business should work for you, not the other way around." by Mike Michalowicz',
  '"Don\'t save what is left after spending; spend what is left after saving." by Warren Buffett',
  '"A big part of financial freedom is having your heart and mind free from worry about the what-ifs of life." by Suze Orman',
  '"It\'s not how much money you make, but how much money you keep." by Robert Kiyosaki',
  '"Beware of little expenses. A small leak will sink a great ship." by Benjamin Franklin',
  '"You must gain control over your money or the lack of it will forever control you." by Dave Ramsey',
];

export const frequencyOptions = [
  {
    id: 0,
    label: "Daily",
  },
  {
    id: 1,
    label: "Weekly",
  },
  {
    id: 2,
    label: "Semi-Monthly",
  },
  {
    id: 3,
    label: "Monthly",
  },
  {
    id: 4,
    label: "Quarterly",
  },
  {
    id: 5,
    label: "Yearly",
  },
];

export const cadenceOptions = [
  {
    id: 0,
    label: "Current Month",
  },
  {
    id: 1,
    label: "Future Months",
  },
  {
    id: 2,
    label: "All Months",
  },
];

export const defaultModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: OFF_WHITE,
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};

export const MediumModalStyle = {
  ...defaultModalStyle,
  width: 500,
};

export const frequencyShortHandMap = (freq: string) => {
  switch (freq) {
    case "Daily":
      return "business day";
    case "Weekly":
      return "week";
    case "Semi-Monthly":
      return "two times a month";
    case "Monthly":
      return "month";
    case "Quarterly":
      return "quarter (March, June, Sept, Dec)";
    case "Yearly":
      return "year";
    default:
      return "month";
  }
};

export const emailAddress = "info.simplebudget@gmail.com";

export const nonPrivatePages = ["/about", "/privacy", "/contact"];

export const noBreadCrumbList = ["/", "/onboarding", ...nonPrivatePages];

export const currencyList = [
  {
    id: 0,
    label: "USD",
  },
  {
    id: 1,
    label: "EUR",
  },
  {
    id: 2,
    label: "JPY",
  },
  {
    id: 3,
    label: "GBP",
  },
  {
    id: 4,
    label: "CHF",
  },
  {
    id: 5,
    label: "AUD",
  },
  {
    id: 6,
    label: "CAD",
  },
];

export const monthSelect = [
  {
    id: 0,
    label: "january",
  },
  {
    id: 1,
    label: "february",
  },
  {
    id: 2,
    label: "march",
  },
  {
    id: 3,
    label: "april",
  },
  {
    id: 4,
    label: "may",
  },
  {
    id: 5,
    label: "june",
  },
  {
    id: 6,
    label: "july",
  },
  {
    id: 7,
    label: "august",
  },
  {
    id: 8,
    label: "september",
  },
  {
    id: 9,
    label: "october",
  },
  {
    id: 10,
    label: "november",
  },
  {
    id: 11,
    label: "december",
  },
];
